/**
 * 存储sessionStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  sessionStorage.setItem(name, content)
}
/**
 * 获取sessionStorage
 */
export const getStore = name => {
  if (!name) return
  let content = sessionStorage.getItem(name)
  try {
    content = JSON.parse(content)
    return content
  } catch (e) {
    return content
  }
}
/**
 * 删除sessionStorage
 */
export const removeStore = name => {
  if (!name) return
  sessionStorage.removeItem(name)
}

export const setLocalStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  localStorage.setItem(name, content)
}

export const getLocalStore = name => {
  if (!name) return
  let content = localStorage.getItem(name)
  try {
    content = JSON.parse(content)
    return content
  } catch (e) {
    return content
  }
}
